<template>
	<a-layout-sider class="mainLeftSider">
	  <div class="itemListDiv" >
		  <h2 class="left-title" ref="menuItemH">我的文件</h2>
		  <div class="menu-div" :style="{height:dynamicHeight + 'px'}"   ref="menuDivCont">
			 <div class="menu-div-cont"  >
				 <template v-for="(item0,index0) in menuListData">	
					<template v-if="item0.children.length>0">
						<div  class="menu-item" :key="item0.id" :index="index0"  :data-id="item0.id"
						 @click="EmptyDataSendToMain(item0.id)"  
						
						><a-icon :type="item0.icon" /><span>{{item0.title}}</span></div>
						<div class="menu-list"  :class="item0.class"  :id="'submenu'+item0.id" :key="'key'+item0.id" >
						<template v-for="(item1,index1) in item0.children">
							<template v-if="item1.children.length>0">
								<div class="menu-item"  :class="item1.class+ ' ' + item1.class2"  :key="item1.id" :index="index1" 	   :data-id="item1.id"
								@click="EmptyDataSendToMain(item1.id)"
								>
									<div class="menu-item1"><a-icon :type="item1.icon" /><span>{{item1.title}}</span></div>
								</div>
								<div class="menu-list"  :class="item1.class"  :id="'submenu'+item1.id" :key="'key'+item1.id" >
								<template v-for="(item11,index11) in item1.children">
									<template v-if="item11.children.length>0">
										<div class="menu-item" :class="item11.class2" :key="item11.id" :index="index11"	   :data-id="item11.id"
										@click="EmptyDataSendToMain(item11.id)"			
										>
											<div class="menu-item11"><a-icon :type="item11.icon" /><span>{{item11.title}}</span></div>
										</div>
										<div class="menu-list" :class="item11.class"  :id="'submenu'+item11.id" :key="'key'+item11.id" >
											<template v-for="(item111,index111) in item11.children">
												<template v-if="item111.children.length>0">
													<div class="menu-item" :class="item111.class2" :key="item111.id" :index="index111"   :data-id="item111.id"
													@click="EmptyDataSendToMain(item111.id)"	
													>
														<div class="menu-item111"><a-icon :type="item111.icon" /><span>{{item111.title}}</span></div>
													</div>
													<div class="menu-list" :class="item111.class"  :id="'submenu'+item111.id" :key="'key'+item111.id" >	
														<template v-for="(item1111,index1111) in item111.children">
															
															<div class="menu-item menu-title" :class="item1111.class3 + ' ' + item1111.class2" :key="'key'+item1111.id" :index="index1111"
															@click="EmptyDataSendToMain(item1111.id)"   :data-id="item1111.id"
															>
																<div class="menu-item1111" :key="'key'+item1111.id">{{item1111.title}}</div>
															</div>
															
														</template>
														
													</div>
												</template>												
												<template v-else>
													<div class="menu-item  menu-title" :class="item111.class3+ ' ' + item111.class2" :key="item111.id" 
															@click="EmptyDataSendToMain(item111.id)"   :data-id="item111.id"
															 >
															<div class="menu-item111" :key="'key'+item111.id">{{item111.title}}</div>
													</div>
												</template>
											</template>
										</div>
									</template>
									<template v-else>
										<div class="menu-item   menu-title"  :class="item11.class3+ ' ' + item11.class2" :key="item11.id" 
												@click="EmptyDataSendToMain(item11.id)"   :data-id="item11.id"
												>
												<div class="menu-item11" :key="'key'+item11.id">{{item11.title}}</div>
										</div>
									</template>
									
									
									
								</template>
								</div>
							</template>
							<template v-else>
								<div class="menu-item   menu-title" :class="item1.class3+ ' ' + item1.class2" :key="item1.id"   :data-id="item1.id"
										@click="EmptyDataSendToMain(item1.id)" >
										<div class="menu-item1" :key="'key'+item1.id">{{item1.title}}</div>
								</div>
							</template>
							
							
							
						</template>
						</div>
					</template>
					<template v-else>
						<div class="menu-item   menu-title" :key="item0.id" @click="EmptyDataSendToMain(item0.id)"   :data-id="item0.id" >{{item0.title}}</div>
					</template>
				 </template>
			 </div>
			 
		  </div>
	  </div>
	</a-layout-sider>
</template>

<script>
	//import { longClickDirective } from 'vue-long-click'
	import storage from 'store'
	import {findById,findParentPath,modifyNestedArrayById,modifyNestedArrayByKeyName,findByIdNumber} from '@/utils/util';
	export default {
	  data() {
	    return {	       
	       screenHeight: 0,
	       dynamicHeight:300, 
		   leftHieght:0,
		   menuListData:[], 
		   isTap:false,
		   isMove:false,
		   timeId:null,
		   tapUpTime:0,		   
		   
		   startX: 0,
			 startY: 0,
			 distanceX: 0,
			 distanceY: 0
	    };
	  },
	  computed: { 
		  menuListVal(){ 
			  return this.$store.state.article.menuList;
		  },
		  LeftHieghtVal(){
			  return this.$store.state.article.leftHieght;
		  } 
	  },
	  watch: { 
		menuListVal(val,oldVal){
			this.menuListData=val;
		},
		LeftHieghtVal(newVal){
			this.LeftHieght=newVal;
		},
	  },
	  components: {
	    // TyphoonInfoTreeSelect,
	  },
	  created(){
		  
		  var _self=this;
		  this.$store.dispatch("article/GetMenuList").then(function(){
			//console.log("created-------------------left4--0");
			var menuListData=_self.$store.state.article.menuList;
			menuListData=modifyNestedArrayByKeyName(menuListData,"class3","active3",function(node){
				node.class3=""
			});
			
			var pplist=_self.$store.state.article.pplist;
			//console.log("created--------------------left4--0:",pplist);			
			if(pplist.length>0)
			{
				for(var i=0;i<pplist.length;i++)
				{
					var ival=pplist[i];		
					if(i==(pplist.length-1))
					{ 	  
					  menuListData=modifyNestedArrayById(menuListData,ival.id,function(node){
						node.class3="active3"
					  });
					}
					else{ 
					  menuListData=modifyNestedArrayById(menuListData,ival.id,function(node){
						node.class="active";
						node.icon="caret-down";
					  });
					}
				}//console.log("created----------------left4--0-setTimeout111:",ival);
				
				
			}	
			_self.$store.commit("article/set_menuList",menuListData);
			
			
		  }); 
		  console.log("created-------------------left4");
	  },
	  mounted() {
		this.updateScreenHeight();
		window.addEventListener('resize', this.updateScreenHeight);		
		
		var _self=this;
		
		document.addEventListener('visibilitychange', this.handleVisibilityChange);
		document.addEventListener('visibilitychange', this.handleBackgroundSwitch);
	  },
	  methods: { 
		updateScreenHeight() {
			var _self=this;
			this.screenHeight = window.innerHeight;
			this.dynamicHeight=this.screenHeight * 0.80;
			var div = _self.$refs.menuDivCont;
			setTimeout(function(){	
				var gd=0;
				var divCont=_self.$refs.menuItemH;
				var resizeObserver1 = new ResizeObserver(entries => {
				   for (let entry of entries) {
					 var cr = entry.contentRect;
					 gd=cr.height;
					 console.log("gd:",gd); 
					 //长度计算
					 var pplist=_self.$store.state.article.pplist;
					 var n=findByIdNumber(_self.$store.state.article.menuList,pplist[pplist.length-1].id);
					 if(n!=null)
					 { 
						 var gd=(n.count/2)*gd;
						 console.log("gd-n:",n); 
						 console.log("gd-m:",gd); 	
					 }				 
					 
					 div.scrollBy(0, gd);
				   }
				});
				resizeObserver1.observe(divCont); // 开始观察目标元素的大小变化。
				
			},500);
			
		  },
		  
		  handleTouchStart(clsId){
			  var _self=this;
			  this.isMove=false;
			  this.startY=0;
			  this.distanceY=0;
			  console.log("handleTouchStart:",clsId);	
			  _self.tapUpTime=0;
			  var t=setInterval(function(){
				  _self.tapUpTime+=0.1;
				  if(_self.tapUpTime>2)
				  {
					  clearInterval(t);
				  }
			  },100)
		  },
		  handleTouchMove(e)
		  {
			var _self=this;
			this.isMove=true;			  
			const currentX = e.touches[0].clientX;			  
			const currentY = e.touches[0].clientY;
			
			this.distanceX = currentX - this.startX; // 水平移动距离
			if(Math.abs(this.startY)<=0)
			{
				this.startY=currentY;
			}
			this.distanceY = currentY - this.startY; // 垂直移动距离
			console.log(`X方向移动: ${this.distanceX}, Y方向移动: ${this.distanceY}`); 
			
		  },
		  handleTouchEnd(clsId){
			var _self=this;
			console.log(`handleTouchEnd: ${this.distanceY}`); 
			if(Math.abs(this.distanceY)<=10)
			{				
				_self.isMove=false;
			}
			
			// if(_self.tapUpTime>2 && _self.isMove==false)
			// {
			// 	_self.handlePressUp(clsId);		//长按事件
			// }
			// else
			// {
			// 	console.log("点击处理...");
			// }
		  },
		  handlePressUp(clsId){
			  var _self=this;  
			  if(_self.isMove==true)
			  {
				return;			  					
			  }
			  _self.isMove=true;
			   _self.tapUpTime=0;
			   this.$confirm({
				  title: '请确认将该分类设置为默认首页', 
				  centered:true,
				  onOk() {					
					var menulist=_self.$store.state.article.menuList;
					var pplist=findParentPath(menulist,clsId);//_self.$store.state.article.pplist;					
					if(pplist.length>0)
					{
						var defaultMenuItem=pplist[pplist.length-1];
						//console.log("pplist1:",pplist);
						_self.$store.commit("article/set_defaultMenuItem",defaultMenuItem);
						_self.$store.dispatch("article/setDefaultMenuItemAction",defaultMenuItem);
						//_self.$store.dispatch("article/GetMenuList");
						_self.setActive3(pplist,1);	
						_self.EmptyDataSendToMain(clsId);
						//console.log("pplist2:",pplist);
						//console.log(defaultMenuItem);
						_self.$message.success("设置成功！");
					}
					else{
						_self.$message.error("未找到二级目录！");
					}
				  },
				  onCancel() {
					console.log('取消');
				  },
				  class: 'loginout',
			  });
		  }, 
		  
		  EmptyDataSendToMain(id,index=-1,index1=-1,index11=-1,index111=-1){
		  			   // 假设我们要传递的数据是'some data'
					   this.$store.commit("article/SetSearchKeyWordsMin",""); 
					   this.$store.commit("article/set_page",0);
					   this.$store.commit("article/set_total",0);
					   this.$store.commit("article/set_lastpage",0);
					   this.$store.commit("article/set_currentpage",0);
		  			   var data=this.menuListData;	 
		  			   if(id>0)
		  			   { 		   
		  				   var arr=findById(data,id);
		  				   this.$store.commit("article/set_seltMenuItem",{id:id,name:arr.name});
		  				   var pplist=findParentPath(data,id);
		  				   this.$store.commit("article/set_pplist",pplist); 
		  				   
		  				   if(arr.class=="active")
		  				   {
		  					   arr['class']="";
		  					   arr['icon']="caret-right";
		  				   }
		  				   else{
		  					   arr['class']="active";
		  					   arr['icon']="caret-down";
		  				   }		  				   
		  				   //console.log("pplist-mainpage:",pplist);
		  				   this.setActive3(pplist);		
		  			   }
					   
					   
		  },
		  
		  setIconV(id,index=-1,index1=-1,index11=-1){
		  			  //console.log("index1:",index1);
		  			  console.log("index:"+index+","+index1+","+index11);
		  			  var data=this.menuListData;  
		  			  this.menuListData=data;
		  			  this.EmptyDataSendToMain(id);
		  },
		  setActive3(pplist,setDefault=0)
		  {
			  var menuListData=this.$store.state.article.menuList;
			  menuListData=modifyNestedArrayByKeyName(menuListData,"class3","active3",function(node){
			  		node.class3=""
			  });
			  if(pplist.length>0)
			  {
			  	  var ival=pplist[pplist.length-1];			  
			  	  menuListData=modifyNestedArrayById(menuListData,ival.id,function(node){
			  		node.class3="active3"
			  	  });
			  }
			  
			  if(setDefault==1)
			  {
				  var defaultMenuItem=this.$store.state.article.defaultMenuItem;
				  console.log("defaultMenuItem:",defaultMenuItem);
				  menuListData=modifyNestedArrayByKeyName(menuListData,"class2","add-right-icon",function(node){
						node.class2=""
				  });
				  if(defaultMenuItem.id!=undefined && defaultMenuItem.id!=null)
				  {			  	 
					 menuListData=modifyNestedArrayById(menuListData,defaultMenuItem.id,function(node){
						node.class2="add-right-icon"
					 });
				  }
			  }
			  this.$store.commit("article/set_menuList",menuListData);
			  console.log("setActive3----------------menuListData:",menuListData);
		  },
		  
		  handleVisibilityChange() {
			 if (document.visibilityState === 'visible') {
			   //console.log('应用回到前台');
			   var pplist=storage.get("now_pplist");//this.$store.state.article.pplist;		
			  // console.log('应用回到前台',pplist);
			 }
		  },
		  handleBackgroundSwitch() {
			   if (document.visibilityState === 'hidden') {
				 //this.pauseMediaPlayback(); // 暂停媒体播放等操作
				 var pplist=this.$store.state.article.pplist;
				 storage.set("now_pplist",pplist);
				 //console.log('应用进入后台',pplist);
			   }
		  },
	  },
	  beforeDestroy() {
		window.removeEventListener('resize', this.updateScreenHeight);
		document.removeEventListener('visibilitychange', this.handleVisibilityChange);  
		document.addEventListener('visibilitychange', this.handleBackgroundSwitch);
	  },
	  
	};
</script>

<style lang="scss" scoped>
	.mainLeftSider{
		background-color: unset;
		width: 240px!important;min-width: 240px!important;max-width: 240px!important;
		.itemListDiv{
			float: right; width:217px;height: 99vh;max-height: 89vh; background-color: #fff; border-radius:12px;
			padding-left:9px;padding-right: 10px; padding-top: 0px; padding-bottom: 12px;
			overflow:hidden;
			.left-title{ font-size: 16px; line-height:40px; font-weight: 600;color:rgba(25, 26, 26, 1); margin-bottom:4px;}
			span,li{color:rgba(48, 49, 51, 1);font-weight: 400;}
			.ant-menu-item-selected{
				background-color:rgba(31, 110, 238, 1) ;color: #fff; border-radius: 10px;
			}
			.menu-div{ 
				display: flow-root;width: 100%; overflow: hidden; overflow-y: auto; 
				.menu-div-cont{ height: auto;}
			}
			
			.add-right-icon{ 
				// background-image: url('/assets/img/main/left-icon-home.png');
				background-repeat: no-repeat; 
				background-position:right 8px; 
				background-size: 16px 16px;
			 }
			 
			.menu-item{width: 100%; height: 32px; line-height: 32px; font-size: 14px; font-weight:400;position: relative;
				cursor: pointer;text-overflow: ellipsis; white-space: nowrap;}
				// .menu-title:hover,
			 .menu-title.active3{ background-color:rgba(31, 110, 238, 1) ;color: #fff; border-radius: 10px; transition:all 0.2s}
			 .menu-div .menu-list{ 
				 display:none;position: relative;width:100%; 
				 .menu-title{
					 overflow: hidden; 
					 -webkit-user-select: none; /* Chrome, Opera, Safari */
					   -moz-user-select: none;    /* Firefox */
					   -ms-user-select: none;    /* Internet Explorer/Edge */
					   user-select: none;        /* Standard syntax */
				   }
			 }
			 .menu-div .menu-item1{
				 width: 96%;margin-left: 4%;cursor: pointer;text-overflow: ellipsis; white-space: nowrap;overflow: hidden;
					 -webkit-user-select: none; /* Chrome, Opera, Safari */
					   -moz-user-select: none;    /* Firefox */
					   -ms-user-select: none;    /* Internet Explorer/Edge */
					   user-select: none;        /* Standard syntax */
				}
			 .menu-div .menu-item11{
				 width: 92%;margin-left: 8%;cursor: pointer;text-overflow: ellipsis; white-space: nowrap;overflow: hidden;
					 -webkit-user-select: none; /* Chrome, Opera, Safari */
					   -moz-user-select: none;    /* Firefox */
					   -ms-user-select: none;    /* Internet Explorer/Edge */
					   user-select: none;        /* Standard syntax */
				 }
			 .menu-div .menu-item111{
				 width: 78%;margin-left: 16%;cursor: pointer;text-overflow: ellipsis; white-space: nowrap;overflow: hidden;
					 -webkit-user-select: none; /* Chrome, Opera, Safari */
					   -moz-user-select: none;    /* Firefox */
					   -ms-user-select: none;    /* Internet Explorer/Edge */
					   user-select: none;        /* Standard syntax */
				 }
			 .menu-div .menu-item1111{
				 width: 75%;margin-left: 20%;cursor: pointer;text-overflow: ellipsis; white-space: nowrap;overflow: hidden;
					 -webkit-user-select: none; /* Chrome, Opera, Safari */
					   -moz-user-select: none;    /* Firefox */
					   -ms-user-select: none;    /* Internet Explorer/Edge */
					   user-select: none;        /* Standard syntax */
				 }
			 .menu-div .active{ display: flow-root;}
		}
		
	}	
</style>
<style>
	.mainLeftSider .ant-menu-submenu-arrow{ display: none;}
	.menu-div .anticon{ margin-right:5px;font-size: 12px; min-width: 12px;color: rgba(144, 147, 153, 1);}	
	@media (max-width:420px){
		.mainLeftSider{
			width: 150px!important;max-width: 150px!important;min-width: 150px!important; 
		}	
	}
</style>